/* Pinned compact summaries sit outside the horizontal scroll container. */
(() => {
  'use strict';
  const controllers=new Map(),desktop=matchMedia('(min-width: 990px)');
  function initialise(scope=document){
    const sections=[...scope.querySelectorAll('[data-product-comparison][data-pin-summary=true]')];
    if(scope.matches?.('[data-product-comparison][data-pin-summary=true]'))sections.unshift(scope);
    for(const section of sections){
      if(controllers.has(section))continue;
      const pin=section.querySelector('[data-comparison-pin]'),rail=section.querySelector('[data-comparison-pin-rail]'),track=section.querySelector('[data-collection-track]'),table=track?.querySelector('table'),head=table?.querySelector('thead');
      if(!pin||!rail||!head)continue;
      const abort=new AbortController(),signal=abort.signal,columns=[...head.querySelectorAll('[data-comparison-product]')],cells=[...rail.children];
      // A sticky header can vary with fonts, menus, viewport or merchant CSS.
      const header=document.querySelector('.site-header');let frame;
      function refresh(){
        cancelAnimationFrame(frame);frame=requestAnimationFrame(()=>{
          const rect=track.getBoundingClientRect(),tableRect=table.getBoundingClientRect(),headRect=head.getBoundingClientRect();
          let top=0;
          if(header){const headerRect=header.getBoundingClientRect(),wrapper=header.closest('.shopify-section'),style=getComputedStyle(wrapper||header);if(['sticky','fixed'].includes(style.position)&&headerRect.bottom>0)top=Math.max(0,headerRect.bottom);}
          section.style.setProperty('--pm-compare-pin-top',top+'px');
          rail.style.width=track.scrollWidth+'px';
          const scroll=track.scrollLeft,rtl=getComputedStyle(track).direction==='rtl';
          columns.forEach((column,index)=>{const cell=cells[index],bounds=column.getBoundingClientRect();if(!cell)return;cell.style.left=(bounds.left-rect.left+scroll)+'px';cell.style.width=bounds.width+'px';cell.inert=bounds.right<=rect.left||bounds.left>=rect.right;});
          rail.style.transform=`translateX(${-scroll}px)`;
          // Measure in this frame before deciding visibility, including long titles.
          pin.hidden=false;
          const height=Math.min(Math.max(88,...cells.map(cell=>cell.firstElementChild?.scrollHeight+24||0)),innerHeight*.35);
          section.style.setProperty('--pm-compare-pin-height',height+'px');
          pin.hidden=!desktop.matches||section.hidden||rect.width===0||headRect.bottom>top||tableRect.bottom<=top+height;
          // RTL scrollLeft is negative; positions above remain physical coordinates.
          rail.dir=rtl?'rtl':'ltr';
        });
      }
      track.addEventListener('scroll',refresh,{signal,passive:true});window.addEventListener('scroll',refresh,{signal,passive:true});window.addEventListener('resize',refresh,{signal});desktop.addEventListener('change',refresh,{signal});
      const observer=typeof ResizeObserver==='undefined'?null:new ResizeObserver(refresh);observer?.observe(track);observer?.observe(head);if(header)observer?.observe(header);
      document.fonts?.ready.then(()=>{if(!signal.aborted)refresh();});refresh();
      controllers.set(section,()=>{abort.abort();observer?.disconnect();cancelAnimationFrame(frame);});
    }
  }
  document.addEventListener('shopify:section:load',event=>initialise(event.target));
  document.addEventListener('shopify:section:unload',event=>{for(const [section,destroy]of controllers)if(event.target.contains(section)){destroy();controllers.delete(section);}});
  initialise();
})();
